import fetch from './../../_node_modules/node-fetch/src/index.js';
import * as z from "zod";
import { API_ENDPOINTS } from "../../constants/API_ENDPOINTS.js";
import { PRISMIC_CLI_USER_AGENT } from "../../constants/PRISMIC_CLI_USER_AGENT.js";
import { decode } from "../../lib/decode.js";
import { BaseManager } from "../BaseManager.js";
import { PrismicRepositorySchema, PrismicRepositoryRole } from "./types.js";
class PrismicRepositoryManager extends BaseManager {
  async readAll() {
    const url = new URL("./repositories", API_ENDPOINTS.PrismicLegacyUserApi);
    const res = await this._fetch({ url });
    if (res.ok) {
      const json = await res.json();
      const { value: repositories, error } = decode(z.array(PrismicRepositorySchema), json);
      if (error) {
        throw new Error(`Failed to decode repositories: ${error.errors.join(", ")}`);
      }
      return repositories;
    } else {
      const text = await res.text();
      throw new Error(`Failed to read repositories`, { cause: text });
    }
  }
  hasWriteAccess(repository) {
    switch (repository.role) {
      case PrismicRepositoryRole.SuperUser:
      case PrismicRepositoryRole.Owner:
      case PrismicRepositoryRole.Administrator:
        return true;
      default:
        return false;
    }
  }
  async checkExists(args) {
    const url = new URL(`./app/dashboard/repositories/${args.domain}/exists`, API_ENDPOINTS.PrismicWroom);
    const res = await this._fetch({
      url,
      skipAuthentication: true
    });
    const text = await res.text();
    if (res.ok) {
      return text === "false";
    } else {
      throw new Error(`Failed to check repository existence for domain \`${args.domain}\``, { cause: text });
    }
  }
  async _fetch(args) {
    let token;
    try {
      token = await this.user.getAuthenticationToken();
    } catch (e) {
      if (!args.skipAuthentication) {
        throw e;
      }
    }
    const extraHeaders = {};
    if (args.body) {
      extraHeaders["Content-Type"] = "application/json";
    }
    if (args.repository) {
      extraHeaders.repository = args.repository;
    }
    return await fetch(args.url.toString(), {
      method: args.method,
      body: args.body ? JSON.stringify(args.body) : void 0,
      headers: {
        ...token !== void 0 ? {
          Authorization: `Bearer ${token}`
        } : {},
        "User-Agent": PRISMIC_CLI_USER_AGENT,
        ...extraHeaders
      }
    });
  }
}
export {
  PrismicRepositoryManager
};
//# sourceMappingURL=PrismicRepositoryManager.js.map
